module.exports = __webpack_public_path__ + "media/upper gi bleeding.c0969d4a.wav";